export enum VersionStatus {
  ACTIVE = 'ACTIVE',
  STANDARD = 'STANDARD',
  TEMPORARY = 'TEMPORARY',
  DRAFT = 'DRAFT',
}
